import React from "react";
import BaseModal from "../../../components/ui/BaseModal";
import { Avatar } from "@mui/material";
import dayjs from "dayjs";
import UserProfileLink from "../../../components/ui/UserProfileLink";

const CommentLogsModal = ({ open, close, logs }) => {
  return (
    <BaseModal open={open} close={() => close(false)}>
      <div className="w-[500px] h-[500px] relative cursor-default overflow-y-auto">
        <div className="border-b sticky top-0  z-10 bg-white px-4 py-3">
          <div className="flex items-center justify-between">
            <h6 className="text-dark font-medium">Edit History</h6>
            <i
              class="fa-regular fa-xmark text-dark cursor-pointer"
              onClick={() => close(false)}
            ></i>
          </div>
        </div>
        <div className="p-4">
          {logs?.map((log) => (
            <div className="flex mb-4 " key={log?.id}>
              <UserProfileLink
                as="div"
                userId={log?.performedBy?.id}
                linkClassName="cursor-pointer"
              >
                <Avatar src={log?.performedBy?.profilePicture} sx={{ width: 34, height: 34 }} />
              </UserProfileLink>
              <div className="flex justify-end flex-col bg-light rounded-xl px-3 py-1.5 ml-3">
                <div className="flex items-center">
                  <UserProfileLink
                    userId={log?.performedBy?.id}
                    className="text-primary font-medium"
                    linkClassName="cursor-pointer hover:underline"
                  >
                    {log?.performedBy?.firstName + " " + log?.performedBy?.lastName}
                  </UserProfileLink>
                  <p className="text-zinc-400 text-[10px] ml-2 mb-0.5">
                    {dayjs(log?.createdAt).fromNow()}
                  </p>
                </div>
                <p className="mr-12">{log?.meta?.to}</p>
              </div>
            </div>
          ))}

          <p className="font-normal text-xs text-neutral-500">
            Edits to comments are visible to everyone who can see this comment.
          </p>
        </div>
      </div>
    </BaseModal>
  );
};

export default CommentLogsModal;
